module.exports = __webpack_public_path__ + "static/media/back-new-11.2f1529d7.jpg";